const ApartmentIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='M4.5 16.5V3A1.5 1.5 0 0 1 6 1.5h6A1.5 1.5 0 0 1 13.5 3v13.5m-9 0h9m-9 0H3A1.5 1.5 0 0 1 1.5 15v-4.5A1.5 1.5 0 0 1 3 9h1.5m9 7.5H15a1.5 1.5 0 0 0 1.5-1.5V8.25a1.5 1.5 0 0 0-1.5-1.5h-1.5m-6-2.25h3m-3 3h3m-3 3h3m-3 3h3'
      />
    </svg>
  );
};

export default ApartmentIcon;
